<template>
  <span
    class="wt-beats-button-wraper"
    :class="classObj"
    v-tooltip="$_tooltip_onToggle"
    ref="tooltipBody"
    @click="$_onClick"
  >
    <!-- <i
      class="wticon"
      :class="{
        'wticon-note-line': !isEnabled,
        'wticon-note-small': isEnabled,
        '-on-show': isEnabled,
      }"
    /> -->

    <i
      class="wticon wt2-link"
      :class="[isEnabled ? 'wticon-show' : 'wticon-hide']"
    />

    <span class="wt2-text-n -label -min-size" v-text="label" />
  </span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import app from 'app';

export default Vue.extend({
  name: 'wtBeatsButton',

  computed: {
    ...mapState('timemachine', {
      showBeats: (state) => state.USE.showBeats,
    }),
    ...mapState({
      storyBackgroundMusic: (state) => state.story.storyBackgroundMusic,
      bgMusicBeatsIsLoading: (state) => state.story.bgMusicBeatsIsLoading,
      bgMusicBeats: (state) => state.story.bgMusicBeats,
    }),
    ...mapGetters('timemachine', ['getBgBeats']),

    classObj() {
      return {
        '-disabled': !this.storyBackgroundMusic,
      };
    },

    isEnabled() {
      return this.showBeats && !!this.storyBackgroundMusic;
    },

    label() {
      return app.culture.beats.shortTitle;
    },

    $_tooltip_onToggle() {
      const state = this.showBeats ? 'on' : 'off';

      return {
        animation: false,
        wrapperClass: 'large -bgbeats',
        trigger: 'hover',
        placement: 'right',
        delay: { show: 300, hide: 0 },
        title: `
          <div class="bgbeats-tooltip">
            <div class="-title">${app.culture.get(
              `beats.tooltip.${state}.title`
            )}</div>
            <div class="-description">${app.culture.get(
              `beats.tooltip.${state}.description`
            )}</div>
          </div>
        `.normalizeSpace(),
        html: true,
      };
    },
  },

  watch: {
    showBeats() {
      this.$nextTick(() => {
        if (!this._isDestroyed) {
          $(this.$refs.tooltipBody).tooltip('show');
        }
      });
    },
  },

  methods: {
    ...mapActions('timemachine', ['TOGGLE_BEATS']),
    $_onClick() {
      if (this.bgMusicBeats.length) {
        this.TOGGLE_BEATS();
      }
    },
  },
});
</script>

<style lang="scss">
.tooltip.wt-preset-tooltip.large.-bgbeats {
  pointer-events: none;
  margin-top: 10px; // move it down

  .tooltip-inner {
    max-width: 220px;
  }
}
</style>

<style lang="scss" scoped>
.wt-beats-button-wraper {
  display: flex;
  align-items: center;
  user-select: none;
  height: 50px;
  cursor: pointer;
  padding-left: 15px;

  & .-on-show {
    color: $wt-orange-dark;
  }

  &.-disabled {
    color: $color-disabled;
    cursor: default;
    pointer-events: none;

    .wt2-link {
      opacity: 0.3;
      color: $color-disabled;
    }
  }

  &:not(.-disabled):hover {
    background-color: rgba(6, 169, 244, 0.1);
  }

  i {
    font-size: 16px;
  }

  span {
    margin: 0 10px 0 10px;
  }

  .-label {
    // cursor: default;
    cursor: pointer;
  }

  .-min-size {
    min-width: 40px;
  }

  .wt2-link {
    padding: 4px 0;
  }
}
</style>
